import _ from 'lodash'

const getName = user => {
  const firstName = user?.displayname
  const lastName = user?.familyname

  if (!firstName) return user.email

  let fullName = ''
  if (firstName) fullName = firstName
  if (lastName) fullName = `${fullName} ${lastName}`
  return fullName.trim()
}

const getShortenedName = user => {
  const firstName = user?.displayname
  const lastName = user?.familyname
  const email = user?.email ?? ''

  if (!firstName) return getTruncatedEmail(email)

  let fullName = ''
  if (firstName) fullName = `${getFirstWord(firstName)}`
  if (lastName) fullName = `${fullName} ${getFirstWord(lastName)}`
  return fullName
}

const getTruncatedEmail = email => {
  return `${email
    .split('')
    .slice(0, 8)
    .join('')}...`
}

const getFirstWord = name => {
  return _.first(name.split(' '))
}

const formatUser = (user = {}) => {
  return {
    id: user._id,
    _id: user._id,
    displayName: user.displayname,
    displayname: user.displayname,
    familyName: user.familyname,
    isDeleted: user.isDeleted,
    familyname: user.familyname,
    name: getName(user),
    shortenedName: getShortenedName(user),
    email: user.email,
    position: user.position,
    status: user.status,
    photo: user?.photo ?? null,
    avatarMediaObject: user?.photo ?? null,
    organization: user?.organization?._id ?? user?.organization,
    isAdmin: user?.isAdmin ?? false,
    isCoach: user?.isCoach ?? false,
    isOrganizationAdmin: user?.isOrganizationAdmin ?? false,
    isSiteAdmin: user?.isSiteAdmin ?? false,
    isRoutineManager: user?.isRoutineManager ?? false,
    canValidateFinancially: user?.canValidateFinancially ?? false,
  }
}

const formatOwner = (user = {}) => {
  const owner = formatUser(user)

  return {
    ...owner,
    isAdmin: user?.isAdmin ?? false,
    isCoach: user?.isCoach ?? false,
    isOrganizationAdmin: user?.isOrganizationAdmin ?? false,
    isSiteAdmin: user?.isSiteAdmin ?? false,
    isRoutineManager: user?.isRoutineManager ?? false,
    canValidateFinancially: user?.canValidateFinancially ?? false,
  }
}

const formatCoach = (user = {}) => {
  const coach = formatUser(user)

  return coach
}

export default {
  formatCoach,
  formatOwner,
  formatUser,
}
